import $rdf from 'rdf-ext';
import { Core } from '../../Constants';
import { rdf, rdfs } from '../../Vocabs';
const rdfType = $rdf.namedNode(rdf.type);
const subClassOf = $rdf.namedNode(rdfs('subClassOf'));
const hydraClass = $rdf.namedNode(Core.Vocab('Class'));
function reAssert(superClass, subClass, dataset, prop) {
    const triplesToReassert = dataset.match(superClass, prop, null, null).toArray();
    triplesToReassert.forEach(quad => {
        dataset.add($rdf.triple(subClass, prop, quad.object));
    });
}
export function inheritFromSuperclasses(dataset) {
    const rootClasses = dataset.match(null, rdfType, hydraClass, null)
        .filter((quad) => {
        return dataset.match(quad.subject, subClassOf, null, null).length === 0;
    })
        .toArray();
    let classQueue = rootClasses.map((quad) => quad.subject);
    const doneClass = [];
    while (classQueue.length) {
        const superClass = classQueue.shift();
        if (!superClass || doneClass.includes(superClass.value)) {
            continue;
        }
        doneClass.push(superClass.value);
        const subclasses = dataset.match(null, subClassOf, superClass, null).toArray().map(q => q.subject);
        classQueue = [...classQueue, ...subclasses];
        subclasses.forEach(subclass => {
            dataset.add($rdf.triple(subclass, rdfType, hydraClass));
            reAssert(superClass, subclass, dataset, $rdf.namedNode(Core.Vocab('supportedProperty')));
            reAssert(superClass, subclass, dataset, $rdf.namedNode(Core.Vocab('supportedOperation')));
        });
    }
}
//# sourceMappingURL=subClassOfInherit.js.map